<template>
  <form-builder-editor-field
    :item="item"
    :show-hide-in-form="true"
    :show-hide-in-preview="true"
    :show-hide-in-reports="true"
    :show-required="true"
    :show-share-with-participant="true"
    :show-is-shared="true"
    v-on="$listeners"
  >
    <div v-if="item.type === 'rating'">
      <div class="form-group">
        <label :for="item.name + '-label-low'">Lowest Rating Text</label>
        <input :id="item.name + '-label-low'" type="text"
               class="form-control"
               v-model="item.minText" min="1" max="19">
      </div>
      <div class="form-group">
        <label :for="item.name + '-label-high'">Highest Rating Text</label>
        <input :id="item.name + '-label-high'" type="text"
               class="form-control"
               v-model="item.maxText" min="1" max="19">
      </div>
    </div>
    <editor-options-list
      :values="item.values"
      :id="item.name"
      :edit-value="true"
    />
  </form-builder-editor-field>
</template>

<script>
import FormBuilderEditorField from "./FormBuilderEditorField";
import EditorOptionsList from "./EditorOptionsList";

export default {
  components: {EditorOptionsList, FormBuilderEditorField},

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  setup() {
    return {}
  }
}
</script>




// WEBPACK FOOTER //
// FormBuilderEditorRating.vue?28cd6cb3